import { Column } from '@tanstack/react-table';

import {
  MultiSelect,
  MultiSelectContent,
  MultiSelectGroup,
  MultiSelectItem,
  MultiSelectTrigger,
  MultiSelectValue,
} from '../shadcn/multi-select';

export function FilterMultiSelect<T>({
  values,
  options,
  column,
  placeholder,
  formatLabel,
}: {
  values: string[];
  options: string[];
  column: Column<T, unknown>;
  placeholder: string;
  formatLabel?: (value: any) => string;
}) {
  return (
    <MultiSelect
      values={values}
      onValuesChange={(values) => {
        column.setFilterValue(values.length > 0 ? values : undefined);
      }}
    >
      <MultiSelectTrigger className="w-full">
        <MultiSelectValue placeholder={placeholder} />
      </MultiSelectTrigger>
      <MultiSelectContent>
        <MultiSelectGroup>
          {options
            .filter((option) => option) // remove falsey values
            .map((option) => (
              <MultiSelectItem key={option} value={option}>
                {formatLabel ? formatLabel(option) : option}
              </MultiSelectItem>
            ))}
        </MultiSelectGroup>
      </MultiSelectContent>
    </MultiSelect>
  );
}
